import React, { memo } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function DementiaCare() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-830">
      <Navbar data-id="element-831" />
      <main className="flex-1" data-id="element-832">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-833">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-834">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-835">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-836" />
              Care Solutions
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-837">
              Dementia Care
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-838">
              Specialized memory care from workers trained in dementia and
              Alzheimer's support. Person-centred approaches that preserve
              dignity and quality of life.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-839">
          <p data-id="element-840">
            Our Dementia Care services provide specialized memory care from
            workers trained in dementia and Alzheimer's support. We focus on
            person-centered approaches that preserve dignity, promote
            independence, and enhance the quality of life for individuals living
            with dementia.
          </p>
          <p data-id="element-841">
            Our caregivers are trained to manage behavioral symptoms, provide
            safe wandering prevention, and offer caregiver respite and relief.
            Every care plan is nurse-supervised, ensuring the highest standards
            of clinical quality and patient safety.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-842" />
    </div>;
}